import React, { useState } from 'react';
import { Grid, Divider, Typography, TextField, Button, Avatar, createMuiTheme, ThemeProvider, CircularProgress, IconButton} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles, styled, withStyles } from '@material-ui/styles';
import { Autocomplete, Box, FormControl, ListItemText, MenuItem, Select } from '@mui/material';
import { Switch, FormControlLabel, SwitchProps } from '@material-ui/core';
import InputMask from 'react-input-mask';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';



const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',

    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: 'bold',
        fontFamily: 'montserrat',
        color: '#686b72'
    },
    informationHeading: {
        fontSize: 14,
        fontFamily: 'montserrat',
        color: '#686b72'
    },
    TypographyData: {
        fontFamily: 'montserrat',
        fontSize: 12,
        color: '#686b72',
    },
    TypographyDataLeft: {
        fontFamily: 'montserrat',
        fontSize: 12,
        color: '#686b72',
        marginLeft: -26
    },
    TextField: {
        width: '100%',
        height: '10%'
    },
    formControl: {
        margin: theme.spacing(1),
        width: '100%',
        height: '10%',
        backgroundColor: 'white',
        borderColor: '#c3c3c3',
        borderWidth: 1,
        borderRadius: 10,
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#c3c3c3',
            },
            '&:hover fieldset': {
                borderColor: '#c3c3c3',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#c3c3c3',
            },
        },
    },
    menuItem: {
        fontSize: 12,
        fontFamily: 'montserrat',
        color: '#686b72',
    },
}));

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 13,

    }
}));

const CustomSwitch = withStyles((theme) => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 3,
        color: '#484fdb',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#484fdb',// Mantém a cor do círculo cinza quando marcado
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.common.white,
                borderColor: theme.palette.grey[500], // Mantém as bordas cinzas quando marcado
            },
        },
    },
    thumb: {
        width: 20,
        height: 20,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 26 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);

const BankOfHoursAndExtraHours = ({
    viewEmployeeRegistration
}) => {
    const classes = useStyles()
    function getMask(value) {
        if (value.startsWith("-")) {
            return '-99:99';
        }
        else {
            return '';
        }
    }
    function formatValue(value) {
        if (!value.startsWith("-") && !isNaN(value)) {
            const formattedValue = value.slice(0, 2) + ':' + value.slice(2);
            return formattedValue;
        } else {
            return value;
        }
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Divider style={{ marginTop: -20 }} />
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}  style={{
                        marginTop: -24}}>
                        <div style={{ display: 'flex', marginTop: 20, marginLeft: 30}}>
                            <LightTooltip title={
                                <Typography style={{ color: '#464a53', fontFamily: 'montserrat', fontSize: 12 }}>
                                    Escolha o Padrão CLT se você trabalhar com Horas Extras e Horas Faltas:
                                    <br /><br />
                                    Esse é o modelo padrão definido pela CLT, aqui as horas não compensam, são calculadas como situações distintas.
                                    Se um funcionário sair mais tarde ou chegar mais cedo, será computado hora extra, já se ele se atrasar ou sair mais cedo será contabilizado Hora Falta. Veja o exemplo abaixo:
                                    <br /><br />
                                    Funcionário deveria entrar às 08:00 e terminar o dia às 18:00<br />
                                    Ele chegou atrasado às 08:15, pensando que poderia compensar isso no final do dia ele decide sair às 18:15<br />
                                    Neste caso o dia dele ficou com 15 minutos de Hora Extra e outros 15 minutos de Hora Falta.<br />
                                    A hora extra será calculada e paga com adicional de 50% sobre o valor da hora<br />
                                    A hora falta será descontada do salário dele.
                                </Typography>}
                                style={{ marginTop: -8, marginRight: -9, borderColor: '#72727a'}}>
                                <IconButton>
                                    <Typography style={{
                                        fontFamily: 'montserrat',
                                        fontSize: 13,
                                        marginLeft: 7,
                                        color: '#72727a',
                                        fontWeight: 'bold',
                                        marginTop: -14,
                                    }}>
                                        Padrão CLT
                                    </Typography>
                                </IconButton>
                                <QuestionMarkIcon
                                    style={{ padding: '4px', color: '#171bf3', marginTop: 7, marginRight: 5 }}
                                />
                            </LightTooltip>
                            <CustomSwitch
                                checked={viewEmployeeRegistration.bankOfHoursData.isBankOfHours}
                                onChange={event => viewEmployeeRegistration.handleChangeBankOfHours(event, 'isBankOfHours')}
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                            <LightTooltip title={
                                <Typography style={{ color: '#464a53', fontFamily: 'montserrat', fontSize: 12 }}>
                                    Escolha essa opção se você já trabalha com Banco de Horas ou irá começar a trabalhar agora.
                                    <br />
                                    No banco de horas ao contrário do modelo padrão da CLT as compensações são possíveis. Veja os dois exemplos abaixo:
                                    <br /><br />
                                    Exemplo 1:<br />
                                    Funcionário deveria entrar às 08:00 e terminar o dia às 18:00<br />
                                    Se ele atrasar e chegar às 08:15, pode ficar até 18:15 e isso não gerará Hora Extra.
                                    <br /><br />
                                    Exemplo 2:
                                    Funcionário tem carga horária de 8h/dia e quer uma folga na segunda-feira,
                                    na semana anterior ele, em acordo com seu superior, trabalha 2h a mais durante 4 dias.<br />
                                    Nesse caso ele terá gerado um crédito de 8h no Banco de Horas, que poderá ser descontado na fogla da segunda-feira.
                                    <br />
                                    Lembrando que o banco de horas dá flexibilidade para o funcionário, mas é sempre a critério da empresa o uso dessas horas.
                                </Typography>}
                                style={{ marginTop: -11, marginLeft: -5 }}
                                disableInteravtive
                            >
                                <QuestionMarkIcon
                                    style={{ padding: '4px', color: '#171bf3', marginTop: 10, marginRight: -7 }}
                                />
                                <IconButton>
                                    <Typography
                                     style={{
                                        fontFamily: 'montserrat',
                                        fontSize: 13,
                                        marginLeft: 9,
                                        marginTop: -14,
                                        color: '#72727a',
                                        fontWeight: 'bold',
                                    }}>
                                        Regime de Banco de horas
                                    </Typography>
                                </IconButton>
                            </LightTooltip>
                        </div>
                    </Grid>
                    {viewEmployeeRegistration.bankOfHoursData.isBankOfHours ?
                        <Grid item xs={5} justify='flex-start'>
                                <Typography className={classes.TypographyDataLeft}>
                                    Saldo inicial (Horas:Minutos)
                                </Typography>
                                <TextField
                                    id="outlined-basic"
                                    className={classes.TextField}
                                    variant="outlined"
                                    value={formatValue(viewEmployeeRegistration.bankOfHoursData.initialValue)}
                                    onChange={event => {
                                        const mask = getMask(event.target.value);
                                        viewEmployeeRegistration.handleChangeBankOfHours(event, 'initialValue', mask);
                                    }}
                                    InputProps={{
                                        style: {
                                            ...styles.InputLeft,
                                            color: '#72727a',
                                            fontWeight: 'bold',
                                        },
                                        inputComponent: InputMask,
                                        inputProps: {
                                            mask: getMask(viewEmployeeRegistration.bankOfHoursData.initialValue),
                                            alwaysShowMask: false,
                                        },
                                    }}
                                />
                            <div style={{ marginTop: 50, marginLeft: -30 }}>
                                <CustomSwitch
                                    checked={viewEmployeeRegistration.bankOfHoursData.extraHoursLimit}
                                    onChange={event => viewEmployeeRegistration.handleChangeBankOfHours(event, 'extraHoursLimit')}
                                    name="checkedA"
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                />
                                <Typography
                                    style={{
                                        fontFamily: 'montserrat',
                                        fontSize: 13,
                                        marginLeft: 50,
                                        marginTop: -25,
                                        color: viewEmployeeRegistration.bankOfHoursData.extraHoursLimit ? '#72727a' : '#afafaf',
                                        fontWeight: viewEmployeeRegistration.bankOfHoursData.extraHoursLimit ? 'bold' : 'normal'
                                    }}
                                > {viewEmployeeRegistration.bankOfHoursData.extraHoursLimit ? 'Limite de 2 horas por dia ativado' : 'Ativar limite  de 2 horas por dia para banco'}
                                </Typography>
                            </div>
                        </Grid>
                        : ''}
                    {viewEmployeeRegistration.bankOfHoursData.isBankOfHours ?
                        <Grid item xs={5}>
                            <Typography className={classes.TypographyData}>
                                Início do Banco de horas
                            </Typography>
                            <TextField
                                id="outlined-basic"
                                type="date"
                                className={classes.TextField}
                                variant="outlined"
                                value={viewEmployeeRegistration.bankOfHoursData.dtFrom}
                                onChange={event => viewEmployeeRegistration.handleChangeBankOfHours(event, 'dtFrom')}
                                InputProps={{
                                    style: {
                                        ...styles.InputRight,
                                        color: '#72727a',
                                        fontWeight: 'bold'

                                    },
                                    inputProps: {
                                        max: "9999-12-31", // Define o valor máximo permitido
                                    },
                                }}
                            />

                            <Typography className={classes.TypographyData} style={{ marginTop: 40 }}>
                                Término do Banco de horas
                            </Typography>
                            <TextField
                                id="outlined-basic"
                                type="date"
                                className={classes.TextField}
                                variant="outlined"
                                value={viewEmployeeRegistration.bankOfHoursData.dtTo}
                                onChange={event => viewEmployeeRegistration.handleChangeBankOfHours(event, 'dtTo')}
                                InputProps={{
                                    style: {
                                        ...styles.InputRight,
                                        color: '#72727a',
                                        fontWeight: 'bold'

                                    },
                                    inputProps: {
                                        max: "9999-12-31", // Define o valor máximo permitido
                                    },
                                }}
                            />
                        </Grid>
                        : ''}
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Divider style={{ marginTop: 10 }} />
            </Grid>
            <Grid item xs={5} />
            <Grid item xs={7} container justify="flex-end" style={{ marginLeft: -10 }}>
                {
                    viewEmployeeRegistration.loading ?
                        <CircularProgress />
                        :
                        <>
                            <Button
                                style={{
                                    ...styles.buttonOne,
                                    color: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.atualizationButton ? '#484fdb' : '#c3c3c3'
                                }}
                                onClick={() => viewEmployeeRegistration.handleClickDiscard('bankOfHours')}

                            >
                                Descartar atualizações
                            </Button>
                            <Button style={{
                                ...styles.buttonTwo,
                                backgroundColor: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.atualizationButton ? '#484fdb' : 'white',
                                color: viewEmployeeRegistration.isUpdate ? 'white' : viewEmployeeRegistration.atualizationButton ? 'white' : '#c3c3c3'
                            }}
                                onClick={viewEmployeeRegistration.createdAndUpdatedBankOfHours}
                            //      disabled={viewEmployeeRegistration.disabledBankHours}
                            >
                                {viewEmployeeRegistration.isUpdate ? 'Salvar' : 'Próximo'}
                            </Button>
                        </>
                }
                <Box style={styles.Box} />
                <Avatar style={{ ...styles.avatar }}>
                    <IconButton onClick={() => viewEmployeeRegistration.handleExpandClick('bankOfHours')} style={{ padding: 0 }}>
                        <ExpandMoreIcon style={{ fontSize: 20, color: viewEmployeeRegistration.isUpdate ? '#484fdb' : '#c3c3c3' }} />
                    </IconButton>
                </Avatar>
            </Grid>

        </Grid >
    );
};


export default BankOfHoursAndExtraHours;

const styles = {
    InputLeft: {
        height: 40,
        padding: '0 14px',
        borderRadius: 10,
        marginLeft: -26
    },
    InputRight: {
        height: 40,
        padding: '0 14px',
        borderRadius: 10,
        marginRight: -25
    },
    buttonOne: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '35%',
        height: 30,
        marginLeft: -10,
        marginRight: 10,
        color: '#c3c3c3',
        fontFamily: 'montserrat',
        fontSize: 10,
        fontWeight: 'bold'
    },
    buttonTwo: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '16%',
        height: 30,
        marginRight: 10,
        color: '#c3c3c3',
        fontFamily: 'montserrat',
        fontSize: 10
    },
    Box: { borderLeft: '1px solid #c3c3c3', height: '30px', marginLeft: '10px', marginRight: 10 },
    avatar: { backgroundColor: 'white', color: '#c3c3c3', border: '1px solid #c3c3c3', width: 30, height: 30, transform: 'rotate(180deg)' }
}
